import { Redirect } from 'react-router-dom';
import { getCustomerDetails, getCSPeople, assignCs, getServiceProviders } from '../fetch';
import React, { useEffect, useState, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const cspage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [redirectToSearchResults, setRedirectToSearchResults] = useState(false);
    const [redirectAccount, setRedirectAccount] = useState(''); // New state for redirect account
    const [customerData, setCustomerData] = useState([]);
    const [selectedCustomerSuccess, setSelectedCustomerSuccess] = useState('');
    const [availableCustomerSuccess, setAvailableCustomerSuccess] = useState([]);
    const [selectedServiceProvider, setSelectedServiceProvider] = useState('');
    const [availableServiceProvider, setAvailableServiceProvider] = useState([]);
    const [selectedCustomerSegment, setSelectedCustomerSegment] = useState('');
    const [showModal_CS, setShowModalForCS] = useState(false);
    const [selectedClientUrl, setSelectedClientUrl] = useState(''); // New state to hold the selected client URL
    const [searchClientUrl, setSearchClientUrl] = useState(''); // New state for search term
    const [showSearchBox, setShowSearchBox] = useState(false); // State to control visibility of the search box
    const [isLoading, setIsLoading] = useState(true); // New state for loading
    const modalRef_addCS = useRef(null);
    const formRef = useRef(null);
    const { instance } = useMsal();
    const currentAccount = instance.getActiveAccount();
    const globalview_role = currentAccount.idTokenClaims['roles'].includes("Global.View");
    const roles = currentAccount.idTokenClaims['roles'];
    /** Pure Sales.Member (no Global.Admin / Trial.Admin / CS.Member) — cannot assign CS */
    const sales_member_role =
        roles.includes("Sales.Member") &&
        !roles.includes("Global.Admin") &&
        !roles.includes("Trial.Admin") &&
        !roles.includes("CS.Member");

    var dataT;

    useEffect(() => {
        getCustDetails(); // Fetch packages when the component mounts
    }, []);

    useEffect(() => {
        fetchCSPeople();
    }, []);

    useEffect(() => {
        if (!showModal_CS || !selectedClientUrl) {
            return;
        }
        getServiceProviders(selectedClientUrl).then((response) => {
            if (response.status === 200 || response.status === 201) {
                setAvailableServiceProvider(response.data ?? []);
            } else {
                setAvailableServiceProvider([]);
            }
        });
    }, [showModal_CS, selectedClientUrl]);

    const handleShowModal_forCS = (clientUrl) => {
        setSelectedClientUrl(clientUrl); // Set the selected client URL
        setSelectedCustomerSuccess('');
        setSelectedServiceProvider('');
        setSelectedCustomerSegment('');
        if (modalRef_addCS.current) {
            modalRef_addCS.current.show = true;
            setShowModalForCS(true);
        }
    };

    const handleCloseModal_forCS = () => {
        if (modalRef_addCS.current) {
            modalRef_addCS.current.show = false;
            setShowModalForCS(false);
        }
    };

    const getCustDetails = () => {
        getCustomerDetails().then(response => {
            if (response.status === 200 || response.status === 201) {
                dataT = response.data;
                setCustomerData(dataT);
            } else {
                setCustomerData([]);
            }
            setIsLoading(false); // Set loading to false when data is fetched
        }).catch(() => {
            setCustomerData([]);
            setIsLoading(false); // Set loading to false in case of error
        });
    };

    const fetchCSPeople = () => {
        getCSPeople().then(response => {
            if (response.status === 200 || response.status === 201) {
                dataT = response.data;
                setAvailableCustomerSuccess(dataT);
            } else {
                setAvailableCustomerSuccess([]);
            }
        });
    };

    const handleCustomerSuccess = (e) => {
        setSelectedCustomerSuccess(e.target.value);
    };

    const handleServiceProvider = (e) => {
        setSelectedServiceProvider(e.target.value);
    };

    const handleCustomerSegment = (e) => {
        setSelectedCustomerSegment(e.target.value);
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent the default form submit action
        setRedirectAccount(searchTerm); // Set the account to redirect to
        setRedirectToSearchResults(true); // Trigger redirection
    };

    const handleSearchClientUrlChange = (e) => {
        setSearchClientUrl(e.target.value);
    };

    const handleSearchIconClick = () => {
        setShowSearchBox(!showSearchBox);
    };

    const handleRowClick = (account) => {
        setRedirectAccount(account);
        setRedirectToSearchResults(true);
    };

    if (redirectToSearchResults) {
        const searchPath = `/signupdetails?account=${encodeURIComponent(redirectAccount)}`;
        return <Redirect to={searchPath} />;
    }

    const handleSubmit_assignCs = (event) => {
        event.preventDefault();

        const formd = event.target;

        const formData = {
            selected_cs: formd.customerSuccess.value,
            serviceProvider: formd.serviceProvider.value,
            customerSegment: formd.customerSegment.value
        };

        console.log(selectedClientUrl);
        console.log(formData.selected_cs);

        assignCs(selectedClientUrl, formData.selected_cs, formData.serviceProvider, formData.customerSegment).then((response) => {
            if ((response.status === 200 || response.status === 201) && (response.data[0].product_package_id !== 0)) {
                toast.success('Customer Success Person Assigned. Page will Reload', {
                    onClose: () => {
                        window.location.reload();
                    },
                    autoClose: 3000
                });
            }
            else {

                toast.error('CS Assignment was unsuccessful. Page will Reload', {
                    onClose: () => {
                        window.location.reload();
                    },
                    autoClose: 3000
                });
            }
        });

        handleCloseModal_forCS();



    };

    const filteredCustomerData = customerData.filter(customer =>
        customer.client_url.toLowerCase().includes(searchClientUrl.toLowerCase())
    );

    return (
        <div>
            <div>
                <center>
                    <form onSubmit={handleSubmit} className="search-form modern-search-form" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <h4 className="modern-section-title">Enter Customer 'account/subdomain' to see details</h4>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px', marginTop: '12px'}}>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                className="search-input modern-search-input"
                                placeholder="Enter Account..."
                                required
                            />
                            <button type="submit" className="modern-get-details-btn-inline">
                                <span role="img" aria-label="Search" style={{marginRight: '7px', fontSize: '1.1em'}}>🔍</span>
                                Get Details
                            </button>
                        </div>
                    </form>
                </center>
                <br />
                <br />
                <br />
            </div>

            <div className="modern-table-outer wide-table-outer">
                <div className="modern-table-card">
                    <div className="modern-table-header-row plain-table-header-row" style={{justifyContent: 'center'}}>
                        <span className="modern-table-title" style={{textAlign: 'center', width: '100%'}}>Unassigned Customers</span>
                        <button className="modern-search-icon-btn" onClick={handleSearchIconClick}>
                            <span role="img" aria-label="Search" style={{fontSize: '1.3em'}}>🔍</span>
                        </button>
                    </div>
                    {showSearchBox && (
                        <div className="modern-table-searchbox-row">
                            <input
                                type="text"
                                value={searchClientUrl}
                                onChange={handleSearchClientUrlChange}
                                className="search-input modern-search-input"
                                placeholder="Search Unassigned Account"
                            />
                        </div>
                    )}
                    <div className="table-responsive">
                        {isLoading ? (
                            <center><div className="loader"></div></center>
                        ) : (
                            <table className="modern-cs-table-fresh">
                                <colgroup>
                                    <col style={{width: '25%'}} />
                                    <col style={{width: '25%'}} />
                                    <col style={{width: '25%'}} />
                                    <col style={{width: '25%'}} />
                                </colgroup>
                                <thead className="modern-cs-table-header-fresh">
                                    <tr>
                                        <th style={{textAlign: 'center'}}>Account</th>
                                        <th style={{textAlign: 'center'}}>Subscription Start Date</th>
                                        <th style={{textAlign: 'center'}}>Product Package</th>
                                        <th style={{textAlign: 'center'}}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {customerData.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: 'center' }}>No Unassigned Customers</td>
                                        </tr>
                                    ) : (
                                        filteredCustomerData.map((customer, index) => (
                                            <tr key={index} onClick={() => handleRowClick(customer.client_url)} className={"CS-clickable-row modern-cs-row-fresh" + (index % 2 === 0 ? " modern-cs-row-zebra" : "")}> 
                                                <td data-label="Account" style={{textAlign: 'center'}}>{customer.client_url}</td>
                                                <td data-label="Subscription Start Date" style={{textAlign: 'center'}}>{customer.subscription_start_date || 'No start date'}</td>
                                                <td data-label="Product Package" style={{textAlign: 'center'}}>{customer.product_package_name}</td>
                                                <td data-label="Actions" style={{textAlign: 'center'}}>
                                                    <button
                                                        type="button"
                                                        className="modern-assign-btn-fresh black-assign-btn no-bold-assign-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleShowModal_forCS(customer.client_url);
                                                        }}
                                                        disabled={globalview_role || sales_member_role}
                                                    >
                                                        <span role="img" aria-label="Assign CS" style={{marginRight: '7px', fontSize: '1.1em'}}>👤</span>
                                                        Assign CS
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            <Modal ref={modalRef_addCS} show={showModal_CS} onHide={handleCloseModal_forCS} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Assign Customer Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form ref={formRef} onSubmit={handleSubmit_assignCs} className="modern-modal-form">
                        <div className="mb-3">
                            <label htmlFor="text2" className="form-label"><strong>Select Customer Success Person: </strong>&nbsp;</label>
                            <select
                                id="customerSuccess"
                                className="form-select"
                                value={selectedCustomerSuccess}
                                onChange={handleCustomerSuccess}
                                required
                            >
                                <option value="">Select Customer Success</option>
                                {availableCustomerSuccess.map((pack) => (
                                    <option key={pack.employee_id} value={pack.employee_id}>
                                        {pack.employeename}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="serviceProvider" className="form-label"><strong>Select Service Provider Type: </strong>&nbsp;</label>
                            <select
                                id="serviceProvider"
                                className="form-select"
                                value={selectedServiceProvider}
                                onChange={handleServiceProvider}
                                required
                            >
                                <option value="">Select Service Provider Type</option>
                                {availableServiceProvider.map((pack) => (
                                    <option key={pack.service_provider_type} value={pack.service_provider_type}>
                                        {pack.service_provider_type}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="customerSegment" className="form-label"><strong>Select Customer Segment: </strong>&nbsp;</label>
                            <select
                                id="customerSegment"
                                className="form-select"
                                value={selectedCustomerSegment}
                                onChange={handleCustomerSegment}
                                required
                            >
                                <option value="">Select Customer Segment</option>
                                <option value="Enterprise">Enterprise</option>
                                <option value="SMB">SMB</option>
                                <option value="DCIM">DCIM</option>
                            </select>
                        </div>
                        <p><strong>Selected Client URL:</strong> {selectedClientUrl}</p>
                        <button type="submit" className="modern-modal-submit-btn" disabled={globalview_role || sales_member_role}>Submit</button>
                    </form>
                </Modal.Body>
            </Modal>
            <ToastContainer className="toastMessage" />
        </div>
    );
};
